import Button from './button';
import ButtonGroup from './button-group';
Button.Group = ButtonGroup;
export default Button;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_antd@4.1.3@antd/es/button/index.js
// module id = 2305
// module chunks = 0